module.exports = __webpack_public_path__ + "media/images/menu/jupiter-719bfc69635c7f89305243e20c137a14.jpg";